import * as React from 'react';
import SvgIcon, { SvgIconProps } from './SvgIcon';

const Eye: React.FunctionComponent<SvgIconProps> = React.memo((props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4752 13.5276C19.8785 12.8178 20 12.2874 20 12C20 11.7126 19.8785 11.1822 19.4752 10.4724C19.0856 9.78658 18.4951 9.04579 17.7348 8.36309C16.2003 6.98512 14.1571 6 12 6C9.84289 6 7.79974 6.98512 6.26519 8.36309C5.50492 9.04579 4.91442 9.78658 4.52477 10.4724C4.12146 11.1822 4 11.7126 4 12C4 12.2874 4.12146 12.8178 4.52477 13.5276C4.91442 14.2134 5.50492 14.9542 6.26519 15.6369C7.79974 17.0149 9.84289 18 12 18C14.1571 18 16.2003 17.0149 17.7348 15.6369C18.4951 14.9542 19.0856 14.2134 19.4752 13.5276ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12ZM22 12C22 15 17.5228 20 12 20C6.47715 20 2 15 2 12C2 9 6.47715 4 12 4C17.5228 4 22 9 22 12Z"
      />
    </SvgIcon>
  );
});

export default Eye;
